import React, { useEffect } from 'react';

import {useTable, usePagination, useSortBy, useRowSelect, useGlobalFilter } from 'react-table'

import { Table, Row, Col } from 'reactstrap';
import { TableHeader } from '../TableHeader';
import { TableBody } from '../TableBody';
import { PageInformation, PageNavigation } from '../Pagination';
import { PCDataTableProps } from './PCDataTable.types';
import { TableEmpty, TableInitLoading } from '../TableEmpty';
import { FormattedMessage } from 'react-intl';
import { PCDataTableInstance } from '.';
import useWhyDidYouUpdate from '../../../hooks/useWhyDidYouUpdate';

/**
 * @author Jungwirth
 * 
 */
export const PCDataTable: React.FC<PCDataTableProps<any,any>> = (
  props: Readonly<PCDataTableProps<any,any>>): JSX.Element => {

  const { 
    data, 
    columns,
    fetchData, 
    loading,
    pageInfo = { totalElements: 0, totalPages: 0 },
    pageSizes = [ 10, 20, 50, 100],
    sorting = false,
    multisort = false,
    serverMode = false,
    // default value [] makes problems, only memoized props works
    defaultSort = [],
    selectedRows,
    small = false,
    filter } = props;

  useWhyDidYouUpdate("PCDataTable", props);

  const {
    headerGroups,
    prepareRow,
    page, // only page rows
    canPreviousPage,
    canNextPage,
    pageCount,
    setGlobalFilter,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    selectedFlatRows,
    // @ts-ignore
    state: { pageIndex, pageSize, sortBy, globalFilter },
  } = useTable(
    {
      columns,
      data,
      /**
       * initialState does not work
       * muss eventuell als useEffect aufgerufen werden
       * */
      // @ts-ignores
      initialState: { pageSize: 10, sortBy: defaultSort },
      pageCount: pageInfo.totalPages,
      manualPagination: serverMode,
      disableSortBy: !sorting,
      disableMultiSort: !multisort,
      manualSortBy: serverMode,
      manualGlobalFilter: true,

      isMultiSortEvent: e => true,

      autoResetPage: serverMode,
      autoResetSortBy: !serverMode,
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  ) as PCDataTableInstance<any>;

  console.log('[PCDataTable]', data, sortBy, pageIndex, pageSize);

  useEffect(() =>  {
    if(selectedRows) {
      console.log('[PCDataTable] selected rows', selectedFlatRows);
      selectedRows(selectedFlatRows);
    }
  },[selectedFlatRows, selectedRows]);

  // update data table filter state
  useEffect(() => {
    gotoPage(0);
    setGlobalFilter(filter);
  }, [filter, gotoPage, setGlobalFilter]);

  // useEffect to load data 
  useEffect(
    () => {
      console.log('[PCDataTable] fetch', pageIndex, pageSize, sortBy, globalFilter);
      if(serverMode) {
        fetchData({pageIndex, pageSize }, sortBy, globalFilter);
      }
    },[serverMode, fetchData, pageIndex, pageSize, sortBy, globalFilter]
  );
  

  if(data.length === 0 && loading) {
    return <TableInitLoading />
  }
  
  // no data in list
  if (data.length === 0 ) {
    return <TableEmpty />;
  }

  // {...getTableProps()} maybe add tableprops to table
  // const tableProps = getTableProps();
  
  return (
    <React.Fragment>
      <Row>
        <Col sm="12" md="12">
          <p className="float-right font-weight-bold">
            {pageInfo.totalElements}{' '}
            <FormattedMessage id="datatable_number_rows"/>
          </p>
        </Col>
      </Row>
      <Table
        hover
        striped
        responsive
        size={small ? 'sm' : ''}
        role="table"
        >
        <TableHeader headerGroups={headerGroups} />
        <TableBody page={page} prepareRow={prepareRow} loading={loading} />
      </Table>
      <Row>
        <Col sm="12" md="6" className="page-info">
          <PageInformation
            pageCount={pageCount} pageIndex={pageIndex}
            pageSize={pageSize} setPageSize={setPageSize} pageSizes={pageSizes} />
        </Col>
        <Col sm="12" md="6" className="page-nav">
          <PageNavigation
            pageIndex={pageIndex}
            gotoPage={gotoPage}
            canPreviousPage={canPreviousPage}
            canNextPage={canNextPage}
            previousPage={previousPage}
            nextPage={nextPage}
            pageCount={pageCount}
          />
        </Col>
      </Row>
    </React.Fragment>

  );
};
